// header.js — StateDecal
// Sticky header behaviour + mobile menu toggle

(function () {
  'use strict';

  var header = document.getElementById('header');
  var menuToggle = document.querySelector('.header__menu-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  var overlay = document.getElementById('header-overlay');
  var isMenuOpen = false;

  // ---- Sticky header ----
  if (header) {
    var headerHeight = header.offsetHeight;
    var lastScrollY = 0;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');

    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY;

      if (scrollY > 10) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }

      // Hide on scroll down past 2x header height; reveal on scroll up
      if (scrollY > lastScrollY && scrollY > headerHeight * 2) {
        header.classList.add('header--hidden');
      } else {
        header.classList.remove('header--hidden');
      }

      lastScrollY = scrollY;
    }, { passive: true });
  }

  // ---- Mobile menu ----
  function openMenu() {
    isMenuOpen = true;
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    if (mobileNav) {
      mobileNav.classList.add('header__mobile-nav--open');
      mobileNav.setAttribute('aria-hidden', 'false');
    }
    if (overlay) {
      overlay.classList.add('header__overlay--visible');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    isMenuOpen = false;
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    if (mobileNav) {
      mobileNav.classList.remove('header__mobile-nav--open');
      mobileNav.setAttribute('aria-hidden', 'true');
    }
    if (overlay) {
      overlay.classList.remove('header__overlay--visible');
    }
    document.body.style.overflow = '';
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      isMenuOpen ? closeMenu() : openMenu();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isMenuOpen) closeMenu();
  });

  // ---- Desktop dropdown hover ----
  var dropdownItems = document.querySelectorAll('.header__nav-item--dropdown');

  dropdownItems.forEach(function (item) {
    var link = item.querySelector('.header__nav-link');
    var dropdown = item.querySelector('.header__dropdown');

    if (!dropdown) return;

    item.addEventListener('mouseenter', function () {
      dropdown.classList.add('header__dropdown--open');
    });

    item.addEventListener('mouseleave', function () {
      dropdown.classList.remove('header__dropdown--open');
    });

    // Keyboard: open on Enter/Space
    if (link) {
      link.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var isOpen = dropdown.classList.contains('header__dropdown--open');
          isOpen
            ? dropdown.classList.remove('header__dropdown--open')
            : dropdown.classList.add('header__dropdown--open');
        }
      });
    }
  });
})();
